import { useTranslation } from "react-i18next";
import StarRatings from "react-star-ratings";
import { selectTextByLanguage, useGetAvailableTranslation } from "../../hooks/global/Languages";

function StarElementsTile(props) {

  let stats = props.stats;
  let title = props.title;
  let emptyText = props.emptyText;
  const availableLanguages = useGetAvailableTranslation();

  const { t, i18n } = useTranslation();
  const lang = i18n.language;

  const starColor = "#f8bf2a";
  const numStars = 5;

  const determineClassName = (difference) => {
    if (!difference && difference !== 0) return "diff none";
    let differenceClassName =
      Number(difference) > 0
        ? "diff positive"
        : Number(difference) < 0
        ? "diff negative"
        : "diff zero";
    return differenceClassName;
  };

  return (
    <div>
      <h4>{title}</h4>
      {stats.length === 0 && (
        <div className="emptyTile">
          <span>{emptyText}</span>
        </div>
      )}
      {stats.slice(0, 5).map((stat, i) => {
      
        const name = selectTextByLanguage(stat?.name , lang, availableLanguages); /*typeof stat.name === 'object' ? stat.name[lang] || stat.name['SL']  : stat.name;*/


        return (
          <div className="tileContent" key={name+i}>
              
            <span>{name}</span>
            <div className="stars rate">
              <StarRatings
                rating={parseFloat(stat.score)}
                starRatedColor={starColor}
                name="rating"
                numberOfStars={numStars}
                starDimension={"16"}
                starSpacing={"1"}
              />
            </div>
            <p className={determineClassName(stat.diff)}>{stat.score}</p>
          </div>
        );
      })}
    </div>
  );
}

export default StarElementsTile;
